import React from "react";
import ReactDOM from "react-dom/client";
import "./scss/construction.scss";
import App from "./components/App";

import * as serviceWorkerRegistration from './serviceWorkerRegistration';


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <App />
);

serviceWorkerRegistration.register();
